exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".promo-text[data-v-06ac2639]{padding-bottom:15px;border-bottom:1px solid #D1D1D1}.not-sure[data-v-06ac2639]{color:#D81E1E;cursor:pointer;text-decoration:underline}\n", ""]);

// exports
